import { MiniTable } from '@moia-dev/pace-web'
import type { ReactNode } from 'react'

export const CardTable = ({ children }: { children: ReactNode }) => {
  return (
    <div
      css={theme => ({
        padding: `${theme.space.Space1} 0`,
        borderTop: '1px solid var(--color-accessory-reduced)',
      })}
    >
      <MiniTable
        css={{
          '& > div > div': {
            borderTop: '1px solid var(--color-accessory-reduced)',
          },
          '& > div > div:first-of-type': {
            borderTop: 0,
          },
        }}
      >
        {children}
      </MiniTable>
    </div>
  )
}
